import React from 'react';
import PropTypes from 'prop-types';

import LoadingIndicator from 'client/generic/LoadingIndicator.react';

import {AuthorDashboardContext} from './AuthorDashboardProvider.react';

// eslint-disable-next-line import/prefer-default-export
export const AuthorDashboardConsumer = (props) => (
  <AuthorDashboardContext.Consumer>
    {(value) => {
      return value[props.field] !== null ? (
        <div>
          {props.children({
            ...props,
            ...value
          })}
        </div>
      ) : (
        <LoadingIndicator />
      );
    }}
  </AuthorDashboardContext.Consumer>
);

AuthorDashboardConsumer.propTypes = {
  field: PropTypes.string
};
